import React from 'react';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { formatEventDate } from '@utils/dates';
import { useRollbarContext } from '@services/rollbar';
import ReduxWrapper from '@services/store';
import ssrProvider from '@services/ssrProvider';
import { GET_DATA_FOR, getServerSideData } from '@services/dataHandler/getPageData';
import { selectEventDetail } from '@features/eventDetail/slices/eventDetailServerSlice';
import { getQueryEventId } from '@features/eventDetail/utils';
import EventLiveResultsTemplate from '@features/eventDetail/templates/EventLiveResultsTemplate';

const LiveResultsPage = () => {
  useRollbarContext('Event : LiveResultsPage');
  const { t } = useTranslation();
  const router = useRouter();
  const event = useSelector(selectEventDetail(getQueryEventId(router.query)));

  return (
    <>
      <Head>
        <title>
          {`${t('head_EventResultsTitle.message', { event: event.name })} ${t('head_siteTitle.message')}`}
        </title>
        <meta
          name="description"
          content={t(
            'head_EventResultsDescription.message',
            {
              eventName: event.name,
              eventDate: formatEventDate(event.date, event.dateFrom, event.dateTo),
              eventLocation: event.location,
              eventSport: event.eventType,
            }
          )}
        />
      </Head>
      <EventLiveResultsTemplate />
    </>
  );
};

export default LiveResultsPage;

export const getServerSideProps = ReduxWrapper.getServerSideProps(
  (store) => async (serverSideContext) => ssrProvider({
    store,
    serverSideContext,
    process: async ({ store }) => {
      await getServerSideData(
        store,
        serverSideContext,
        GET_DATA_FOR.EVENT_LIVE_RESULTS
      );
    },
  })
);
